export function createSurveyRoot(id: string) {
  const element = document.createElement('div');

  element.id = id;

  Object.assign(element.style, {
    position: 'relative',
    width: '100%',
    height: '100%',
    minHeight: '480px',
  });

  return element;
}

export function createSurveyScript(src: string) {
  const script = document.createElement('script');

  script.src = src;
  script.type = 'text/javascript';
  script.fetchPriority = 'high';

  return script;
}

export function lockScroll() {
  const body = document.body.style.overflow;
  const html = document.documentElement.style.overflow;

  document.body.style.overflow = 'hidden';
  document.documentElement.style.overflow = 'hidden';

  return () => {
    document.body.style.overflow = body;
    document.documentElement.style.overflow = html;
  };
}
